import request from '@/utils/request'
import { GetSelfUrl } from '@/utils/request'
import router from '@/router'
import { getToken, setToken, removeToken } from '@/utils/auth'
import commondata from '@/commondata.js'
import { getEnumList, getStoreBase, getUserBase } from '@/api/base'
import { Toast } from 'vant'

const base32 = require('base32')
const state = {
  token: getToken(), // 'getToken()',
  name: '',
  avatar: '',
  permission: null
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  }
}

const actions = {
  wechatLogin({ commit }, info) {
    const { code, state, url, system } = info
    var thirdUrl = GetSelfUrl() + 'loginCallbackThird?system=' + system + '&url=' + url
    console.log('thirdUrl', thirdUrl)
    request({
      url: '/user/wechatLogin',
      method: 'post',
      params: { code: code, state: state, url: thirdUrl }
    })
      .then(response => {
        if (!response.data) {
          router.push('/store/index')
        }
        const token = response.data.token
        console.log('response.data', response.data)
        console.log('token', token)
        commit('SET_TOKEN', token)
        setToken(token)
        // 进行三方微信授权登录
        if (response.data.isNeedThirdLogin) {
          window.location.href = response.data.thirdLoginUrl
        } else {
          // console.log('wechatLogin', url)
          if (url.indexOf('/') >= 0) {
            router.push(url)
          } else {
            router.push(base32.decode(url))
          }
          Toast.clear()
        }
      })
  },
  wechatThirdLogin({ commit }, info) {
    const { code, state, url } = info
    request({
      url: '/user/wechatThirdLogin',
      method: 'post',
      params: { code: code, state: state }
    })
      .then(response => {
        Toast.clear()
        if (!response.success) {
          router.push('/store/index')
          return
        }
        if (response.data === true) {
          commit('SET_TOKEN', undefined)
          alert('已经成功关联旧系统账号,请重新登录!')
        }
        if (url.indexOf('/') >= 0) {
          router.push(url)
        } else {
          router.push(base32.decode(url))
        }
      })
  },
  // 重新登录
  reLogin({ commit }) {
    console.log('reLogin')
    removeToken()
    commit('SET_TOKEN', undefined)
  },
  wechatThirdLoginInfo({ commit }, info) {
    const { code, state, url } = info
    request({
      url: '/user/wechatThirdLoginInfo',
      method: 'post',
      params: { code: code, state: state }
    })
      .then(response => {
        Toast.clear()
        if (!response.success) {
          router.push('/store/index')
          return
        }
        if (url.indexOf('/') >= 0) {
          router.push(url)
        } else {
          router.push(base32.decode(url))
        }
      })
  },
  getWxLoginUrl({ commit }, url) {
    return new Promise((resolve, reject) => {
      request({
        url: '/user/GetWxLoginUrl',
        method: 'post',
        params: { url }
      })
        .then(response => {
          commit('SET_TOKEN', undefined)
          const { data } = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
    })
  },
  getAlipayLogin({ commit }, code) {
    console.log('getAlipayLogin request', code)
    return new Promise((resolve, reject) => {
      request({
        url: '/user/aliPayLogin',
        method: 'post',
        data: { authCode: code }
      })
        .then(response => {
          console.log('getAlipayLogin response', response)
          if (response.success && response.data) {
            commit('SET_TOKEN', response.data.token)
            setToken(response.data.token)
          }
          // const { data } = response
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  },
  getEnumList({ commit, state }) {
    return new Promise((resolve, reject) => {
      getEnumList().then(response => {
        commondata.enumList = response.data
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStoreBase({ commit, state }) {
    return new Promise((resolve, reject) => {
      getStoreBase().then(response => {
        if (response.success) {
          commondata.storeBase = response.data
        } else {
          commondata.storeBase = undefined
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUserBase({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserBase().then(response => {
        if (response.success) {
          commondata.userBase = response.data
        } else {
          commondata.userBase = undefined
        }
        resolve(commondata.userBase)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
